import { useTranslations } from 'next-intl';
import { ButtonGhost } from '@portals/ui-kit';
import { Button } from '@/_kit/button';
import { EButtonColor, EButtonSize } from '@/_kit/button/_types';
import { ETextSize } from '@/_kit/text/_types';
import { Text as CustomText } from '@/_kit/text';

type TProps = {
  name: string;
  isLink?: boolean;
  onClick: () => void;
};

export const CardButton = ({ name, isLink, onClick }: TProps) => {
  const translations = useTranslations();

  return isLink ? (
    <ButtonGhost onClick={onClick} size="m" text={translations(name)} />
  ) : (
    <Button
      backgroundColor={EButtonColor.EMPTY}
      onClick={onClick}
      size={EButtonSize.MEDIUM}
      strokeColor={EButtonColor.BLACK}
    >
      <CustomText
        size={ETextSize.SMALL}
        text={translations(name)}
        variant="body"
      />
    </Button>
  );
};
